import { render } from "./baseButton.vue?vue&type=template&id=7ce96d96&scoped=true"
import script from "./baseButton.vue?vue&type=script&lang=js"
export * from "./baseButton.vue?vue&type=script&lang=js"

import "./baseButton.vue?vue&type=style&index=0&id=7ce96d96&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce96d96"]])

export default __exports__